export const  APIHeaders = {
    "Accept": "application/json",
    'Content-Type': "application/json"
};
export const APIHeadersForMultipartFormData = {
    "Accept": "application/json"
};
